/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75086ResActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export type IAPI75086ResOtherDataObjMapValueObj = {};
    
  
    
export interface IAPI75086ResOtherDataObj {
  
  /** String */
  mapKey?: IAPI75086ResOtherDataObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI75086ResOtherDataObjMapValueObj;
  
};
    
  
    
export interface IAPI75086ResTreeDataItem {
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 岗位名称 */
  jobName?: string;
  
};
    
  



export interface API75086Req {
  
  /** 会议内容 */
  meetingContent?: string;
  /** 文件地址 */
  fileUrl?: string;
};



export interface API75086Res {
  /**   */
  id?: string;
  /**   */
  sendTime?: string;
  /**   */
  content?: string;
  /**   */
  source?: string;
  /** ActionResp  */
  actions?: IAPI75086ResActionsItem[];
  /**   */
  timesTotal?: number;
  /**   */
  timesLeft?: number;
  /**   */
  isLine?: boolean;
  /** (该参数为map)  */
  otherData?: IAPI75086ResOtherDataObj;
  /** TreeNodeResult  */
  treeData?: IAPI75086ResTreeDataItem[];
  
};


// 接口函数 75086 生成会议纪要

export interface IUsePostAPI75086Return {
  /** 生成会议纪要: 接口请求状态 */
  isAPI75086Loading: boolean;
  /** 生成会议纪要: 接口请求返回数据 */
  dataAPI75086: API75086Res;
  /**  生成会议纪要: 接口数据请求方法 */
  fetchAPI75086Data: (inputs: API75086Req, config?: YWRequestConfig) => Promise<API75086Res>;
  /** 生成会议纪要: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75086 = ():IUsePostAPI75086Return => {
  let isMount = true;
  const [isAPI75086Loading, setIsAPI75086Loading] = useState(false);
  const [dataAPI75086, setDataAPI75086] = useState<API75086Res>({} as API75086Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/meetingMinutes`;

  const fetchAPI75086Data = async (inputs: API75086Req, config?: YWRequestConfig): Promise<API75086Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75086Req>) || {}) as API75086Req;
    
  
    if ( isMount ) {
      setIsAPI75086Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75086Res>(`${basePath}/yoaichat-web/chat/meeting/meetingMinutes`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75086(res || {} as API75086Res);
        setIsAPI75086Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75086Loading(false);
      }
      return false as unknown as API75086Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75086Loading,
    dataAPI75086,
    fetchAPI75086Data,
    requestUrl,
  }
}

